import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type Parameter = {
    toggle: boolean;
};

export const DispatchSetToggle: CustomApiHandler<Parameter, boolean> = props => {
    props.dispatch({
        type: "Custom/ProductList/SetFilterValue",
        result: props.parameter.toggle,
    });
};

export const chain = [DispatchSetToggle];

const hideAndShowFilterHandler = createHandlerChainRunner(chain, "hideAndShowFilterHandler");
export default hideAndShowFilterHandler;
